<template>
  <el-container  style="display: block;">
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <el-row :span="2" style="margin-top: 30px;">
          输入名称:<el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          关键词:<el-input v-model="dqpm" style="width: 150px;" placeholder="关键词"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="valuef" @change="fenzu()"  filterable placeholder="请选择" >
              <el-option
                v-for="item in optionf"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="xiaoguo"   multiple placeholder="请选择" >
              <el-option
                v-for="item in xiaoguoArr"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="baoshan"   filterable placeholder="请选择" >
              <el-option
                v-for="item in baoshanArr"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="dikuang"   multiple placeholder="请选择" >
              <el-option
                v-for="item in dikuangArr"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <div class="block">
          <span class="demonstration">日期选择:</span>
          <el-date-picker
            v-model="timestc"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd">
          </el-date-picker>

          </div>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          角度尺:<el-input v-model="dz" style="width: 150px;" placeholder="请输入角度范围"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          时间尺:<el-input v-model="timej" style="width: 150px;" placeholder="请输入时间间隔范围"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          层级尺:<el-input v-model="ceng" style="width: 150px;" placeholder="请输入层级"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          透视尺:<el-input v-model="tou" style="width: 150px;" placeholder="请输入透视"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          速率尺:<el-input v-model="su" style="width: 150px;" placeholder="请输入速率范围"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          缩放尺:<el-input v-model="bi" style="width: 150px;" placeholder="请输入比例"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          地球坐标:<el-input v-model="dqzuobiao" style="width: 150px;" placeholder="地球坐标"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          城市:<el-input v-model="dqcs" style="width: 150px;" placeholder="城市"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          角标动作:<el-input v-model="jiaobiao" style="width: 150px;" placeholder="请输入角标动作"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          特殊层级:<el-input v-model="teshucengji" style="width: 150px;" placeholder="请输入特殊层级"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          省份:<el-input v-model="dqshenfen" style="width: 150px;" placeholder="省份"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          经纬范围:<el-input v-model="dqjwfw" style="width: 150px;" placeholder="经纬范围"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          关键词\经纬坐标:<el-input v-model="dqgjc" style="width: 150px;" placeholder="关键词\经纬坐标"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          半径范围:<el-input v-model="dqbj" style="width: 150px;" placeholder="半径范围"></el-input>
      </el-row>

      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="jcs"  filterable placeholder="请选择" >
              <el-option
                v-for="item in jcss"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="sx"  filterable placeholder="请选择" >
              <el-option
                v-for="item in sxs"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="value"  filterable placeholder="请选择" >
              <el-option
                v-for="item in options"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="valueg"  filterable placeholder="请选择" >
              <el-option
                v-for="item in optiong"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          添加图片:<el-input v-model="addImage" style="width: 150px;" placeholder="请输入图片名称"></el-input>
          <el-button type="success" round @click="addImageCheck()">添加</el-button>
      </el-row>
      <el-row style="margin-top: 30px;">

        <div v-for="(item,indexs) in imageList" :key="indexs" style="float: left;">
          <img width="100%"  :src="item.img" alt="" style="width: 100px;height: 100px;">
          <i class="el-icon-delete" @click="delImage(indexs)" style="margin-left: 10px;"></i>
        </div>

      </el-row>
      <!-- <el-row style="margin-top: 30px;">
        <el-upload
          ref="my-upload"
          action="http://fencip.yoooooo.com/index.php/index/data/pythonImgSave"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :on-success="handleAvatarSuccess"
          :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </el-row> -->
      <el-row :span="2" style="margin-top: 30px;">
         <el-col :span="3" >

           <el-time-select
             style="margin-bottom: -1px;margin-right: -21px;"
             v-model="time1"
             :picker-options="{
               start: '00:00',
               step: '00:01',
               end: '24:00'
             }"
             placeholder="选择开始时间">
           </el-time-select>
         </el-col>
         <el-col :span="3">
           <el-time-select
             v-model="time2"
             :picker-options="{
               start: '00:00',
               step: '00:01',
               end: '24:00'
             }"
             placeholder="选择结束时间">
           </el-time-select>
         </el-col>
         <el-col :span="2" style="text-align: center;">
           <el-input v-model="at" style="width: 150px;" placeholder="请输入百分比"></el-input>
         </el-col>
         <el-col :span="1" style="text-align: center;">
           <el-button type="primary" style="background-color: #409eff;" @click="addTime()" round>添加时段</el-button>
         </el-col>
      </el-row>

      <el-row :span="2" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="times"
            height="300"
          	border
          	style="width: 25%;margin-left: 0;height: 800px;text-align: center;">
          	<el-table-column
              prop="time"
              width="200"
          	  label="时段"
          	   >

          	</el-table-column>
          	<el-table-column
              prop="bai"
              width="150"
          	  label="百分比"
          	   >
          	</el-table-column>

            <el-table-column
              width="180"
              label="操作"
               >
               <template slot-scope="scope">
                 <i class="el-icon-delete" @click="delTime(scope.$index)"></i>
               </template>
            </el-table-column>
            </el-table>
          </template>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="seachName" style="width: 150px;" placeholder="请输入搜索词"></el-input>
          <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
          <el-button round :class="{'pai':pait==1}" @click="pai(1)">开关排序</el-button>
          <el-button round :class="{'pai':pait==2}" @click="pai(2)">时间排序</el-button>
      </el-row>
    </el-row>
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <template>
        <el-table
      	:data="tableData"
        height="1500"
      	border
      	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
        <el-table-column

          width="100"
          label="开关"
           >
           <template slot-scope="scope">
                <div style="color: greenyellow;"  @click="kg(2,scope.row.id)" v-if="scope.row.status == 1">开</div>
                <div style="color: red;"  @click="kg(1,scope.row.id)" v-if="scope.row.status == 2">关</div>
                <div style="color: blue;margin-top: 20px;"  @click="changeT(17,scope.row.bsc,scope.row.id)" >{{scope.row.bsc}}</div>
                <div style="color: blue;margin-top: 20px;"  @click="changeT(16,scope.row.tlc,scope.row.id)" >{{scope.row.tlc}}</div>

           </template>
        </el-table-column>
        <el-table-column

          width="180"
          label="名称"

           >
            <template slot-scope="scope">
                <div  @click="changeT(1,scope.row.name,scope.row.id)">{{scope.row.name}}</div>
                <div  @click="copy(1,scope.row.id)" style="color: #409eff;margin-top: 20px;">(复制)</div>

            </template>
        </el-table-column>
        

      	<!-- <el-table-column

          width="900"
      	  label="图片"
      	   >
           <template slot-scope="scope">
             <div v-for="(items,indexs) in scope.row.img" :key="indexs" style="float: left;margin-right: 20px;">


               <div style="float: left;">

                 <el-button type="info" round @click="imageNewChange(items.id,items.name)">{{items.name}}</el-button>

                  <i class="el-icon-circle-close" style="position: absolute;margin-left: 10px;margin-top: 15px;" @click="del(items.id)"></i>
               </div>
               <div style="float: left;margin-right: 20px;" @click="dischange(1,items.dis,items.id)">
                  <p style="width: 120px;height: 100px;text-align: center;font-size: 10px;">{{items.dis}}</p>
               </div>
               <div style="float: left;margin-right: 20px;" @click="dischange(2,items.w,items.id)">
                  <p style="width: 120px;height: 100px;text-align: center;font-size: 10px;">w:{{items.w}}</p>
               </div>
               <div style="float: left;margin-right: 20px;" @click="dischange(3,items.h,items.id)">
                  <p style="width: 120px;height: 100px;text-align: center;font-size: 10px;">h:{{items.h}}</p>
               </div>

             </div>
             <el-button type="success" round @click="addNewImage(scope.row.id)">添加图片</el-button>

           </template>
      	</el-table-column> -->
        <el-table-column

          width="750"
          label="图片"
           >
           <template slot-scope="scope">
             <el-tooltip class="item" effect="dark" :content="scope.row.imggname" placement="right">
             <div style="float: left;margin-right: 20px;margin-top: 10px;color: blue;" @click="seeImage(scope.row.id)">
                查看图片分组
             </div>
             </el-tooltip>


             <el-button type="success" round @click="addNewImage(scope.row.id)">添加图片</el-button>
             <el-button type="success" round @click="addNewImages(scope.row.id)">添加组图</el-button>

           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="展示效果"
           >
           <template slot-scope="scope">
               <div  @click="changexiaoguo(scope.row.xiaoguo,scope.row.id)">{{scope.row.xiaoguo}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="爆闪效果"
           >
           <template slot-scope="scope">
               <div  @click="changebaoshan(scope.row.baoshan,scope.row.id)">{{scope.row.baoshan}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="底框选择"
           >
           <template slot-scope="scope">
               <div  @click="changedikuang(scope.row.dikuang,scope.row.id)">{{scope.row.dikuang}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="250"
          label="日期"
           >
           <template slot-scope="scope">
               <div  @click="changeRiqi(scope.row.riqi,scope.row.id)">{{scope.row.riqi}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="200"
          label="时间段"
           >
           <template slot-scope="scope">
             <div style="color: blue;margin-bottom: 20px;"  @click="changeT(18,scope.row.zyc,scope.row.id)" >{{scope.row.zyc}}</div>
             <div  v-for="(items,indexs) in scope.row.time" :key="indexs" @click="ct(items.id,items.time,items.bai)">
               <div style="float: left;">{{items.time}} </div>
               <div style="float: left;">#{{items.bai}} </div>
               <div style="float: left;"><i class="el-icon-circle-close" style="margin-left: 10px;" @click="delEc(items.id)"></i></div>
             </div>
             <i v-if="scope.row.time.length == 0" style="margin-left: 30px;" @click="changeTime(scope.row.id)" class="el-icon-plus el-icon-circle-plus-outline"></i>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="透视"
           >
           <template slot-scope="scope">
               <div  @click="changeT(14,scope.row.tou,scope.row.id)">{{scope.row.tou}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="层级"
           >
           <template slot-scope="scope">
               <div  @click="changeT(15,scope.row.ceng,scope.row.id)">{{scope.row.ceng}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="分组"

           >
           <template slot-scope="scope">
               <div  @click="changeT(8,scope.row.zu,scope.row.id)">{{scope.row.zu}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="进/出"

           >
           <template slot-scope="scope">
               <div  @click="changeT(13,scope.row.jcs,scope.row.id)">{{scope.row.jcs}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="比例"

           >
           <template slot-scope="scope">
               <div  @click="changeT(11,scope.row.bi,scope.row.id)">{{scope.row.bi}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="星空粒子"

           >
           <template slot-scope="scope">
               <div  @click="changeT(12,scope.row.sx,scope.row.id)">{{scope.row.sx}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="面判定"

           >
           <template slot-scope="scope">
               <div  @click="changeT(2,scope.row.tm,scope.row.id)">{{scope.row.tm}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="角度范围"
           >
           <template slot-scope="scope">
               <div  @click="changeT(3,scope.row.dz,scope.row.id)">{{scope.row.dz}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="轨迹"

           >
           <template slot-scope="scope">
               <div v-if="scope.row.gui"  @click="changeT(4,scope.row.gui,scope.row.id)">{{scope.row.gui}}</div>
               <div v-else  @click="changeT(4,scope.row.gui,scope.row.id)">修改</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="时间间隔范围"

           >
           <template slot-scope="scope">
               <div v-if="scope.row.timea"  @click="changeT(5,scope.row.timea,scope.row.id)">{{scope.row.timea}}</div>
               <div v-else  @click="changeT(5,scope.row.timea,scope.row.id)">修改</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="速率范围"

           >
           <template slot-scope="scope">
               <div v-if="scope.row.su"  @click="changeT(6,scope.row.su,scope.row.id)">{{scope.row.su}}</div>
               <div v-else  @click="changeT(6,scope.row.su,scope.row.id)">修改</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="地球坐标"
           >
           <template slot-scope="scope">
               <div  @click="changeT(19,scope.row.dqzuobiao,scope.row.id)">{{scope.row.dqzuobiao}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="城市"
           >
           <template slot-scope="scope">
               <div  @click="changeT(20,scope.row.dqcs,scope.row.id)">{{scope.row.dqcs}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="省份"
           >
           <template slot-scope="scope">
               <div  @click="changeT(21,scope.row.dqshenfen,scope.row.id)">{{scope.row.dqshenfen}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="经纬范围"
           >
           <template slot-scope="scope">
               <div  @click="changeT(22,scope.row.dqjwfw,scope.row.id)">{{scope.row.dqjwfw}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="关键词\经纬范围"
           >
           <template slot-scope="scope">
               <div  @click="changeT(23,scope.row.dqgjc,scope.row.id)">{{scope.row.dqgjc}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="半径范围"
           >
           <template slot-scope="scope">
               <div  @click="changeT(24,scope.row.dqbj,scope.row.id)">{{scope.row.dqbj}}</div>
           </template>
        </el-table-column>
        <el-table-column
        
          width="100"
          label="关键词"
           >
           <template slot-scope="scope">
               <div  @click="changeT(25,scope.row.dqpm,scope.row.id)">{{scope.row.dqpm}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="角标动作"
           >
           <template slot-scope="scope">
               <div  @click="changeT(26,scope.row.jiaobiao,scope.row.id)">{{scope.row.jiaobiao}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="特殊层级"
           >
           <template slot-scope="scope">
               <div  @click="changeT(27,scope.row.teshucengji,scope.row.id)">{{scope.row.teshucengji}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="80"
          label="操作"
           >
           <template slot-scope="scope">
             <i class="el-icon-delete" @click="delAll(scope.row.id)"></i>
           </template>






        </el-table-column>
        </el-table>
      </template>
      <div class="page">
      	<el-pagination
      	  @size-change="loadData()"
      	  @current-change="loadData()"
      	  :current-page.sync="page"
      	  :page-size="20"
      	  background
      	  layout="total,prev, pager, next, jumper"
      	  :total="count">
      	</el-pagination>
      </div>
    </el-row>
    <el-dialog
      title="修改时间段"
      :visible.sync="ctDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="ct_time"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="ctDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doCt()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加"
      :visible.sync="timeVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="timesadd"/>
      <span slot="footer" class="dialog-footer">
    	<el-button style="margin-top: 10px;" @click="timeVisible = false">取 消</el-button>
    	<el-button style="margin-top: 10px;" type="primary" @click="doEc()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="changes"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="centerDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibled"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibled = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleds"
      width="30%"
      >
      <span>确认删除整组图片？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibleds = false">取 消</el-button>
    	<el-button type="primary" @click="doDells()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="高度尺"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加图片"
      :visible.sync="imgVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="imgName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doAddImg()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加图片组"
      :visible.sync="imgVisibleG"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="imgNameG"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisibleG = false">取 消</el-button>
    	<el-button type="primary" @click="doAddImgG()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改日期"
      :visible.sync="imgVisiblecTime"
      width="30%"
      center>
      <el-date-picker
        v-model="timesc"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisiblecTime = false">取 消</el-button>
    	<el-button type="primary" @click="doChangeTime()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改效果"
      :visible.sync="imgVisiblecxiaoguo"
      width="30%"
      center>
      <el-select v-model="xiaoguoc"   multiple placeholder="请选择" >
          <el-option
            v-for="item in xiaoguoArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisiblecxiaoguo = false">取 消</el-button>
    	<el-button type="primary" @click="dochangexiaoguo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改爆闪效果"
      :visible.sync="imgVisiblecbaoshan"
      width="30%"
      center>
      <el-select v-model="baoshanc"   filterable placeholder="请选择" >
          <el-option
            v-for="item in baoshanArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisiblecbaoshan = false">取 消</el-button>
    	<el-button type="primary" @click="dochangebaoshan()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改底框选择"
      :visible.sync="imgVisiblecdikuang"
      width="30%"
      center>
      <el-select v-model="dikuangc"   multiple placeholder="请选择" >
          <el-option
            v-for="item in dikuangArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisiblecdikuang = false">取 消</el-button>
    	<el-button type="primary" @click="dochangedikuang()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改图片"
      :visible.sync="imgVisiblec"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="imgNamec"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisiblec = false">取 消</el-button>
    	<el-button type="primary" @click="doChangeImg()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="查看图片"
      :visible.sync="seeimgVisiblec"
      width="50%"
      center>
      <el-row  style="margin-top: 30px;" v-for="(items,indexs) in seeimgs">
          <div style="text-align: center;float: left;">
            {{items.name}}
          </div>
        <div style="text-align: center;float: left;color: red;margin-left: 20px;" @click="dels(items.value[0].id)">
          组删除
        </div>
          <div  style="text-align: center;float: left;margin-left: 30px;" v-for="(item,index) in items.value">
            <div>
              {{item.name}}
              <i class="el-icon-circle-close" style="position: absolute;margin-left: 5px;" @click="del(item.id)"></i>
            </div>
          </div>
      </el-row>
      </span>
    </el-dialog>
  </el-container>

</template>

<script>

  export default {
    data() {
       return {
         page:1,
         count:0,
         dialogImageUrl: '',
         dialogVisible: false,
         tableData:[],
         imageList:[],
         name:'',
         dialogVisibled:false,
         delId:0,
         options:[{'name':'1面','value':'1面'},{'name':'2面','value':'2面'},{'name':'3面','value':'3面'},{'name':'4面','value':'4面'}],
         value:'2面',
         changes:'',
         centerDialogVisible:false,
         t:1,
         c_id:0,
         dz:'0-0',
         tm:'0',
         time1:'',
         time2:'',
         at:100,
         times:[],
         timeStr:'',
         timeVisible:false,
         timec1:'',
         timec2:'',
         atc:100,
         timesc:[],
         timeStrc:'',
         ec_id:0,
         optiong:[{'name':'直线','value':'直线'},{'name':'弧线','value':'弧线'}],
         valueg:'直线',
         su:'0-0',
         timej:'0-0',
         ct_id:0,
         ct_time:'',
         ctDialogVisible:false,
         optionf:[{'name':'不分组','value':'不分组'},{'name':'组1','value':'组1'},{'name':'组2','value':'组2'},{'name':'组3','value':'组3'},{'name':'组4','value':'组4'},{'name':'组5','value':'组5'},{'name':'组6','value':'组6'},{'name':'组7','value':'组7'},{'name':'组8','value':'组8'},{'name':'组9','value':'组9'},{'name':'组10','value':'组10'}],
         valuef:'不分组',
         bi:'100',
         sx:'上',
         sxs:[{'name':'上','value':'上'},{'name':'下','value':'下'}],
         jcs:'双向',
         jcss:[{'name':'进','value':'进'},{'name':'出','value':'出'},{'name':'双向','value':'双向'}],
         disDialogVisible:false,
         changeDis:'',
         disId:0,
         disName:'',
         tou:'100',
         ceng:'0',
         addImage:'',
         imgVisible:false,
         imgName:'',
         imgId:0,
         imgVisiblec:false,
         imgNamec:'',
         imgIdc:0,
         tlc:'否',
         bsc:'100',
         zyc:'否',
         dist:0,
         seachName:'',
         timesadd:'',
         pait:1,
         seeimgVisiblec:false,
         seeimgs:[],
         imgVisibleG:false,
         imgNameG:'',
         dialogVisibleds:false,
         dqzuobiao:'',
         dqcs:'全国',
         dqshenfen:'全国',
         dqjwfw:'无',
         dqgjc:'无',
         dqbj:'全部',
         dqpm:'无',
         timestc:[],
         timesc:[],
         timesc_id:0,
         imgVisiblecTime:false,
         xiaoguoArr:['双脚弹跳','顶部跳入','底部跳入','X轴旋转','Y轴旋转','画轴展开','Y轴弹跳','X轴弹跳','一般呼吸','巨大呼吸','渐现渐消','随机效果'],
         xiaoguo:['随机效果'],
         xiaoguoc:['随机效果'],
         imgVisiblecxiaoguo:false,
         xiaoguoc_id:0,
         baoshanArr:['彩色爆闪','无'],
         baoshan:'无',
         baoshanc:'无',
         imgVisiblecbaoshan:false,
         baoshanc_id:0,
         jiaobiao:'无',
         teshucengji:'否',
         dikuangArr:['新闻底框','电影底框','节日底框','正菱形','五角星','横向棱形','圆角长矩形','无'],
         dikuang:['无'],
         dikuangc:['无'],
         imgVisiblecdikuang:false,
         dikuangc_id:0,

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
      var lett = this;
       document.onkeydown = function(e) {
       var key = window.event.keyCode;
       if (key == 13) {
         lett.seach();
       }
      }
    },

	methods:{
    changedikuang(dikuang,id){
      this.dikuangc_id = id
      this.imgVisiblecdikuang = true
    },
    dochangedikuang(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.dikuangc_id,
          dikuang:this.dikuangc.join(','),
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/zxdqdikuang'
      })
      .then(res=>{
        this.imgVisiblecdikuang = false
        this.dikuangc_id = 0
        this.dikuangc = ['无']
      	this.loadData()

      })
      .catch(err=>{

      });
    },
    changebaoshan(baoshan,id){
      this.baoshanc_id = id
      this.imgVisiblecbaoshan = true
    },
    dochangebaoshan(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.baoshanc_id,
          baoshan:this.baoshanc,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/zxdqbaoshan'
      })
      .then(res=>{
        this.imgVisiblecbaoshan = false
        this.baoshanc_id = 0
      	this.loadData()

      })
      .catch(err=>{

      });
    },
    changexiaoguo(xiaoguo,id){
      this.xiaoguoc_id = id
      this.imgVisiblecxiaoguo = true
    },
    dochangexiaoguo(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.xiaoguoc_id,
          xiaoguo:this.xiaoguoc.join(','),
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/zxdqxiaoguo'
      })
      .then(res=>{
        this.imgVisiblecxiaoguo = false
        this.xiaoguoc_id = 0
        this.xiaoguoc = ['随即效果']
      	this.loadData()

      })
      .catch(err=>{

      });
    },

    changeRiqi(time,id){
      this.timesc_id = id
      this.imgVisiblecTime = true
    },
    doChangeTime(){
      let timesc = '0';
      if(this.timesc != ''&&this.timesc != null&&this.timesc != []){
      	timesc = this.timesc[0]+','+this.timesc[1];
      }
      // console.log(timesc)
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.timesc_id,
          time:timesc
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/zxdqTimes'
      })
      .then(res=>{
        this.imgVisiblecTime = false
        this.timesc = []
      	this.loadData()

      })
      .catch(err=>{

      });

    },
    seeImage(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
          t:2
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementszListSeezdq'
      })
      .then(res=>{
        this.seeimgVisiblec = true;
      	this.seeimgs = res.data.list;

      })
      .catch(err=>{

      });
    },
    pai(t){
      this.pait = t;
      this.p = 1;
      this.loadData();
    },
    seach(){
      this.loadData();
    },
    imageNewChange(id,name){
      this.imgIdc = id;
      this.imgNamec = name;
      this.imgVisiblec = true;
    },
    doChangeImg(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.imgNamec,
          id:this.imgIdc,
          t:2

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonImgSaveChangeNewzdq'
      })
      .then(res=>{
         if(res.data.code == 200){
            this.loadData();
            this.imgVisiblec = false;
         }else{

           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    doAddImgG(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.imgNameG,
          id:this.imgId,
          t:2

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonImgSaveMoreNewgzdq'
      })
      .then(res=>{
         if(res.data.code == 200){
            this.loadData();

            this.imgVisibleG = false;
         }else{

           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    doAddImg(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.imgName,
          id:this.imgId,
          t:2

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonImgSaveMoreNewzdq'
      })
      .then(res=>{
         if(res.data.code == 200){
            this.loadData();

            this.imgVisible = false;
         }else{

           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    addNewImage(id){
      this.imgId = id;
      this.imgVisible = true;
    },
    addNewImages(id){
      this.imgId = id;
      this.imgVisibleG = true;
    },
    delImage(index){
      this.imageList.splice(index,1);
    },
    addImageCheck(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.addImage,

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/addImageCheck'
      })
      .then(res=>{
         if(res.data.code == 200){

            this.imageList.push({'img':res.data.data.img,'gname':res.data.data.gname,'name':res.data.data.name,'size':res.data.data.size,'w':res.data.data.w,'h':res.data.data.h,'chi':res.data.data.chi,'url':res.data.data.url,'zhiling':res.data.data.zhiling})
         }else{
           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    copy(t,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          t:t
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonCopyzdq'
      })
      .then(res=>{
        this.$message({
        	type: 'sucsess',
        	message: '复制成功'
        });
         this.loadData()

      })
      .catch(err=>{

      });
    },
    kg(p,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          p:p,
          t:1
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/statusChangezdq'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },
    UploadUrl(id){
      return "http://fencip.yoooooo.com/index.php/index/data/pythonImgSaveMore?t=2&id="+id
    },
    UploadUrls(id){
      return "http://fencip.yoooooo.com/index.php/index/data/pythonImgSaveChange?t=2&id="+id
    },
    handleAvatarSuccessch(res, file) {
      this.loadData();
      // this.imageList.push(file.response.data)
    },
    handleAvatarSuccessdis(res, file) {
      this.clearFiles()
      this.loadData();

      // this.imageList.push(file.response.data)
    },
    dischange(t,name,id){
      this.dist = t
      this.disId = id
      this.disName = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.disId,
          t:2,
          dist:this.dist,
          name:this.disName,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementDisChangezdq'
      })
      .then(res=>{
         this.disDialogVisible = false
         this.loadData()

      })
      .catch(err=>{

      });
    },
    fenzu(){
      if(this.valuef!='不分组'){
        this.tableData.forEach(item =>{
          if(item.name == this.name && item.zu == this.valuef){
            console.log(item)
            this.timej = item.timea
            this.su = item.su
            this.value = item.tm
            this.valueg = item.gui
            this.times = []
            console.log(item.time)
            item.time.forEach(val=>{
              this.times.push({'time':val.time,'bai':val.bai})
            })
            this.zuTime()

          }

        })
      }

    },
    ct(id,time,bai){
      this.ct_id = id
      this.ct_time = time+'#'+bai
      this.ctDialogVisible = true
    },
    doCt(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.ct_id,
          time:this.ct_time
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/timesChangezdq'
      })
      .then(res=>{
         this.ctDialogVisible = false
         this.ct_id = 0
         this.ct_time = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    changeTime(id){
      this.ec_id = id
      this.timeVisible = true
    },
    addTime(){
      this.times.push({'time':this.time1+'-'+this.time2,'bai':this.at})
      this.zuTime()
    },
    delTime(index){
      this.times.splice(index,1);
      this.zuTime()
    },
    zuTime(){
      let a = []
      this.times.forEach(function(item,index){
        a.push(item.time+'#'+item.bai)
      })
      this.timeStr = a.join(',')
    },
    addTimec(){
      this.timesc.push({'time':this.timec1+'-'+this.timec2,'bai':this.atc})
      this.zuTimec()
    },
    delTimec(index){
      this.timesc.splice(index,1);
      this.zuTimec()
    },
    zuTimec(){
      let a = []
      this.timesc.forEach(function(item,index){
        a.push(item.time+'#'+item.bai)
      })
      this.timeStrc = a.join(',')
    },
    doEc(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.ec_id,
          type:1,
          time:this.timesadd
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementszDoeczdq'
      })
      .then(res=>{
         this.timeVisible = false
         this.timeStrc = ''
         this.timesc = []
         this.ec_id = 0

         this.loadData()

      })
      .catch(err=>{

      });
    },
    delEc(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementszDeleczdq'
      })
      .then(res=>{

         this.loadData()

      })
      .catch(err=>{

      });
    },
    changeT(t,n,id){
      this.c_id = id
      this.t = t
      this.changes = n
      this.centerDialogVisible = true
    },
    doChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.c_id,
          t:this.t,
          n:this.changes
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementszChangezdq'
      })
      .then(res=>{
         this.centerDialogVisible = false
         this.c_id = 0
         this.t = ''
         this.changes = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    clearFiles(){
      this.$refs['my-upload'].clearFiles();
    },
    handleRemove(file, fileList) {

      this.imageList = []
      fileList.forEach((item)=>{
        this.imageList.push(item.response.data)
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      this.imageList.push(file.response.data)
    },
    delAll(id){
      this.type = 1
      this.delId = id
      this.dialogVisibled = true
    },
    dels(id){
      this.type = 2
      this.delId = id
      this.dialogVisibleds = true
    },
    del(id){
      this.type = 2
      this.delId = id
      this.dialogVisibled = true
    },
    doDell(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.delId,
          type:this.type
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementszDelzdq'
      })
      .then(res=>{
         this.dialogVisibled = false
         this.loadData()

      })
      .catch(err=>{

      });
    },
    doDells(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.delId,
          type:this.type
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementszDelszdq'
      })
      .then(res=>{
         this.dialogVisibleds = false
         this.loadData()

      })
      .catch(err=>{

      });
    },
    add(){
      if(this.imageList.length == 0){
        this.$message({
        	type: 'error',
        	message: '请选择图片'
        });
        return false
      }
      if(this.tm.length == 0){
        this.$message({
        	type: 'error',
        	message: '请填写信息'
        });
        return false
      }
      if(this.dz.length == 0){
        this.$message({
        	type: 'error',
        	message: '请填写信息'
        });
        return false
      }
      let timestc = '0';
      if(this.timestc != ''&&this.timestc != null&&this.timestc != []){
      	timestc = this.timestc[0]+','+this.timestc[1];
      }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.name,
          type:2,
          tm:this.value,
          dz:this.dz,
          su:this.su,
          timej:this.timej,
          valueg:this.valueg,
          img:JSON.stringify(this.imageList),
          time:this.timeStr,
          zu:this.valuef,
          bi:this.bi,
          sx:this.sx,
          jcs:this.jcs,
          tou:this.tou,
          ceng:this.ceng,
          tlc:this.tlc,
          bsc:this.bsc,
          zyc:this.zyc,
          dqzuobiao:this.dqzuobiao,
          dqcs:this.dqcs,
          dqshenfen:this.dqshenfen,
          dqjwfw:this.dqjwfw,
          dqgjc:this.dqgjc,
          dqbj:this.dqbj,
          dqpm:this.dqpm,
          riqi:timestc,
          xiaoguo:this.xiaoguo.join(','),
          jiaobiao:this.jiaobiao,
          teshucengji:this.teshucengji,
          baoshan:this.baoshan,
          dikuang:this.dikuang.join(',')
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementszAddzdq'
      })
      .then(res=>{
         obj.excelData.forEach(function(item,index){
          obj.excelData[index]['timeStart'] = obj.timeStart
          obj.excelData[index]['timeEnd'] = obj.timeEnd
        })
         this.loadData()
         this.name = ''
         this.imageList = []
         this.timeStr = ''
         this.times = []
         this.timestc = []
         this.clearFiles()
      })
      .catch(err=>{

      });
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          t:this.pait,
          p:this.page,
          name:this.seachName,
          type:2,
    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/elementszListNewzdq'
    	})
    	.then(res=>{
        this.seeimgVisiblec = false;
    		this.tableData = res.data.list;
    		this.count = res.data.count;

    	})
    	.catch(err=>{

    	});
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .pai{
    background-color:rgb(64, 158, 255);
  }
</style>



// WEBPACK FOOTER //
// src/components/main/elementzxdq.vue